module.exports = {
  contextPath: 'orion-api'
}
